import { Autocomplete, TextField } from "@mui/material";
import LabelGeral from "./LabelGeral";

export default function InputAutoComplete({
  label,
  value,
  options,
  change,
  placeholder,
  style,
}) {
  return (
    <div>
      <LabelGeral
        nome={label}
        estilo={{
          fontSize: 18,
        }}
      />

      <Autocomplete
        disablePortal
        options={options}
        sx={style}
        value={value}
        onChange={(e, valor) => change(valor)}
        renderInput={(params) => <TextField {...params} label={placeholder} />}
      />
    </div>
  );
}
